"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemoveModalContent_1 = require("./RemoveModalContent");
exports.default = RemoveModalContent_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/RemoveModalContent/index.js
// module id = 113
// module chunks = 8